// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file calendar/event_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file calendar/event_model.proto.
 */
export const file_calendar_event_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChpjYWxlbmRhci9ldmVudF9tb2RlbC5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QisgMKDUNhbGVuZGFyRXZlbnQSFwoPcHJvdmlkZXJFdmVudElkGAEgASgJEg0KBXRpdGxlGAIgASgJEhMKC3N0YXJ0VGltZVRzGAMgASgDEhEKCWVuZFRpbWVUcxgEIAEoAxIOCgZhbGxEYXkYBSABKAgSEAoIdGltZVpvbmUYBiABKAkSEAoIbG9jYXRpb24YByABKAkSEwoLZGVzY3JpcHRpb24YCCABKAkSFgoOcmVjdXJyZW5jZVR5cGUYCSABKAkSEAoIY2hhdExpbmsYCiABKAkSEAoIY2FsbExpbmsYCyABKAkSMQoJcmVtaW5kZXJzGAwgAygLMh4uY29tLmdlbS5iZmYuY29udHJhY3QuUmVtaW5kZXISEAoIcGFyZW50SWQYDSABKAkSFgoOaW5pdGlhdG9yRW1haWwYDiABKAkSNwoMcGFydGljaXBhbnRzGA8gAygLMiEuY29tLmdlbS5iZmYuY29udHJhY3QuUGFydGljaXBhbnQSNgoHYWNjb3VudBgQIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyQWNjb3VudCJeCgtQYXJ0aWNpcGFudBINCgVlbWFpbBgBIAEoCRJAChBjb25maXJtYXRpb25UeXBlGAIgASgOMiYuY29tLmdlbS5iZmYuY29udHJhY3QuQ29uZmlybWF0aW9uVHlwZSJvCghSZW1pbmRlchIwCgR0eXBlGAEgASgOMiIuY29tLmdlbS5iZmYuY29udHJhY3QuUmVtaW5kZXJUeXBlEgwKBHRpbWUYAiABKAMSDAoEdW5pdBgDIAEoCRIVCg10aW1lSW5NaW51dGVzGAQgASgDIloKD0NhbGVuZGFyQWNjb3VudBIwCgR0eXBlGAEgASgOMiIuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsZW5kYXJUeXBlEhUKDXByb3ZpZGVyRW1haWwYAiABKAkiYQoVQ2FsZW5kYXJBY2NvdW50U3RhdHVzEjYKB2FjY291bnQYASABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxlbmRhckFjY291bnQSEAoIaXNBY3RpdmUYAiABKAgiUQoXU3Vic2NyaWJlVG9DYWxlbmRhclB1c2gSNgoHYWNjb3VudBgBIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyQWNjb3VudCoxCgxSZW1pbmRlclR5cGUSCwoHVU5LTk9XThAAEgkKBVBPUFVQEAESCQoFRU1BSUwQAipIChBDb25maXJtYXRpb25UeXBlEg0KCU5PX0FOU1dFUhAAEgwKCEFDQ0VQVEVEEAESDAoIREVDTElORUQQAhIJCgVNQVlCRRADKi8KDENhbGVuZGFyVHlwZRIKCgZHT09HTEUQABIKCgZZQU5ERVgQARIHCgNFV1MQAio0Cg5DYWxlbmRhckFjdGlvbhIKCgZDUkVBVEUQABIKCgZVUERBVEUQARIKCgZERUxFVEUQAkIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.bff.contract.CalendarEvent
 */
export type CalendarEvent = Message<'com.gem.bff.contract.CalendarEvent'> & {
  /**
   * @generated from field: string providerEventId = 1;
   */
  providerEventId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int64 startTimeTs = 3;
   */
  startTimeTs: bigint;

  /**
   * @generated from field: int64 endTimeTs = 4;
   */
  endTimeTs: bigint;

  /**
   * @generated from field: bool allDay = 5;
   */
  allDay: boolean;

  /**
   * @generated from field: string timeZone = 6;
   */
  timeZone: string;

  /**
   * @generated from field: string location = 7;
   */
  location: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * @generated from field: string recurrenceType = 9;
   */
  recurrenceType: string;

  /**
   * @generated from field: string chatLink = 10;
   */
  chatLink: string;

  /**
   * @generated from field: string callLink = 11;
   */
  callLink: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.Reminder reminders = 12;
   */
  reminders: Reminder[];

  /**
   * @generated from field: string parentId = 13;
   */
  parentId: string;

  /**
   * @generated from field: string initiatorEmail = 14;
   */
  initiatorEmail: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.Participant participants = 15;
   */
  participants: Participant[];

  /**
   * @generated from field: com.gem.bff.contract.CalendarAccount account = 16;
   */
  account?: CalendarAccount;
};

/**
 * Describes the message com.gem.bff.contract.CalendarEvent.
 * Use `create(CalendarEventSchema)` to create a new message.
 */
export const CalendarEventSchema: GenMessage<CalendarEvent> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 0);

/**
 * @generated from message com.gem.bff.contract.Participant
 */
export type Participant = Message<'com.gem.bff.contract.Participant'> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: com.gem.bff.contract.ConfirmationType confirmationType = 2;
   */
  confirmationType: ConfirmationType;
};

/**
 * Describes the message com.gem.bff.contract.Participant.
 * Use `create(ParticipantSchema)` to create a new message.
 */
export const ParticipantSchema: GenMessage<Participant> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 1);

/**
 * @generated from message com.gem.bff.contract.Reminder
 */
export type Reminder = Message<'com.gem.bff.contract.Reminder'> & {
  /**
   * @generated from field: com.gem.bff.contract.ReminderType type = 1;
   */
  type: ReminderType;

  /**
   * @generated from field: int64 time = 2;
   */
  time: bigint;

  /**
   * @generated from field: string unit = 3;
   */
  unit: string;

  /**
   * @generated from field: int64 timeInMinutes = 4;
   */
  timeInMinutes: bigint;
};

/**
 * Describes the message com.gem.bff.contract.Reminder.
 * Use `create(ReminderSchema)` to create a new message.
 */
export const ReminderSchema: GenMessage<Reminder> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 2);

/**
 * @generated from message com.gem.bff.contract.CalendarAccount
 */
export type CalendarAccount = Message<'com.gem.bff.contract.CalendarAccount'> & {
  /**
   * @generated from field: com.gem.bff.contract.CalendarType type = 1;
   */
  type: CalendarType;

  /**
   * @generated from field: string providerEmail = 2;
   */
  providerEmail: string;
};

/**
 * Describes the message com.gem.bff.contract.CalendarAccount.
 * Use `create(CalendarAccountSchema)` to create a new message.
 */
export const CalendarAccountSchema: GenMessage<CalendarAccount> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 3);

/**
 * @generated from message com.gem.bff.contract.CalendarAccountStatus
 */
export type CalendarAccountStatus = Message<'com.gem.bff.contract.CalendarAccountStatus'> & {
  /**
   * @generated from field: com.gem.bff.contract.CalendarAccount account = 1;
   */
  account?: CalendarAccount;

  /**
   * @generated from field: bool isActive = 2;
   */
  isActive: boolean;
};

/**
 * Describes the message com.gem.bff.contract.CalendarAccountStatus.
 * Use `create(CalendarAccountStatusSchema)` to create a new message.
 */
export const CalendarAccountStatusSchema: GenMessage<CalendarAccountStatus> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 4);

/**
 * @generated from message com.gem.bff.contract.SubscribeToCalendarPush
 */
export type SubscribeToCalendarPush = Message<'com.gem.bff.contract.SubscribeToCalendarPush'> & {
  /**
   * @generated from field: com.gem.bff.contract.CalendarAccount account = 1;
   */
  account?: CalendarAccount;
};

/**
 * Describes the message com.gem.bff.contract.SubscribeToCalendarPush.
 * Use `create(SubscribeToCalendarPushSchema)` to create a new message.
 */
export const SubscribeToCalendarPushSchema: GenMessage<SubscribeToCalendarPush> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_model, 5);

/**
 * @generated from enum com.gem.bff.contract.ReminderType
 */
export enum ReminderType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: POPUP = 1;
   */
  POPUP = 1,

  /**
   * @generated from enum value: EMAIL = 2;
   */
  EMAIL = 2,
}

/**
 * Describes the enum com.gem.bff.contract.ReminderType.
 */
export const ReminderTypeSchema: GenEnum<ReminderType> =
  /*@__PURE__*/
  enumDesc(file_calendar_event_model, 0);

/**
 * @generated from enum com.gem.bff.contract.ConfirmationType
 */
export enum ConfirmationType {
  /**
   * @generated from enum value: NO_ANSWER = 0;
   */
  NO_ANSWER = 0,

  /**
   * @generated from enum value: ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: MAYBE = 3;
   */
  MAYBE = 3,
}

/**
 * Describes the enum com.gem.bff.contract.ConfirmationType.
 */
export const ConfirmationTypeSchema: GenEnum<ConfirmationType> =
  /*@__PURE__*/
  enumDesc(file_calendar_event_model, 1);

/**
 * @generated from enum com.gem.bff.contract.CalendarType
 */
export enum CalendarType {
  /**
   * @generated from enum value: GOOGLE = 0;
   */
  GOOGLE = 0,

  /**
   * @generated from enum value: YANDEX = 1;
   */
  YANDEX = 1,

  /**
   * @generated from enum value: EWS = 2;
   */
  EWS = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CalendarType.
 */
export const CalendarTypeSchema: GenEnum<CalendarType> =
  /*@__PURE__*/
  enumDesc(file_calendar_event_model, 2);

/**
 * @generated from enum com.gem.bff.contract.CalendarAction
 */
export enum CalendarAction {
  /**
   * @generated from enum value: CREATE = 0;
   */
  CREATE = 0,

  /**
   * @generated from enum value: UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * @generated from enum value: DELETE = 2;
   */
  DELETE = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CalendarAction.
 */
export const CalendarActionSchema: GenEnum<CalendarAction> =
  /*@__PURE__*/
  enumDesc(file_calendar_event_model, 3);
